meedy.controller('meedy.selectResourceForCalendarTermPopupController', ['$rootScope', '$scope', '$mdDialog', 'resourceDetails',
    'title', 'term',
    function ($rootScope, $scope, $mdDialog, resourceDetails, title, term) {

        function setData() {
            $scope.title = title;
            $scope.forms = {
                resourceForm: null
            };

            $scope.resourceDetails = resourceDetails;
            $scope.term = term;
            $scope.selectedResource = null;
        }

        function setPermissions() {
        }

        function setListeners() {

        }

        function setActions() {
            $scope.save = function () {
                $scope.forms.resourceForm.$setSubmitted();
                if($scope.forms.resourceForm.$valid) {
                    $mdDialog.hide($scope.selectedResource);
                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };
        }

        function configureInterface() {

        }

        function initialize() {

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
